import { render, staticRenderFns } from "./ResetPasswordView.vue?vue&type=template&id=455ab926"
import script from "./ResetPasswordView.vue?vue&type=script&lang=js"
export * from "./ResetPasswordView.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordView.vue?vue&type=style&index=0&id=455ab926&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports